<template>
  <div class="donut-box">
      <div class="donut-wrapper">
          <key-value class="donut-value" :key-value="value" :percentage="percentage"></key-value>
          <div ref="donut" class="ct-chart ct-square"></div>
      </div>
      <div class="text-semibold">{{ title }}</div>
      <!-- <div class="text-muted">{{ valueRating }}</div> -->
  </div>
</template>

<script>
import Chartist from 'chartist'
import KeyValue from '@/components/KeyValue'
import windowSize from '@/window-size'
export default {
  name: 'donut',
  props: ['keyValue', 'percentage', 'title'],
  data () {
    return {}
  },
  computed: {
    valueRating: function () {
      if (this.value == null) return 'Ikke tilgængelig'
      else if (this.value < 0) return 'Ikke tilfredsstillende'
      else if (this.value >= 0 && this.value < 25) return 'Tilfredsstillende'
      else return 'God'
    },
    value: function () {
      if (this.keyValue == null) return this.keyValue
      else return this.percentage ? Math.sign(this.keyValue) * Math.round(Math.abs(this.keyValue)) : this.keyValue.value
    },
    donutWidth: function () {
      return windowSize.size === 'xxs' ? 10 : 15
    }
  },
  methods: {
    draw: function () {
      var color
      if (this.value == null) color = 'grey'
      else if (this.value < 0) color = 'red'
      else if (this.value > 0 && this.value < 25) color = 'yellow'
      else if (this.value >= 25) color = 'green'

      var reverse = this.value < 0

      var first = {
          value: Math.abs(Math.abs(this.value) > 100 ? 100 : this.value),
          className: 'donut-' + color
      }

      var second = {
          value: 100 - Math.abs(Math.abs(this.value) > 100 ? 100 : this.value),
          className: 'donut-grey'
      }

      Chartist.Pie(this.$refs.donut, {
          series: [reverse ? second : first, reverse ? first : second]
      }, {
          donut: true,
          donutWidth: this.donutWidth,
          showLabel: false
      })
    }
  },
  watch: {
    'keyValue': function () { this.draw() }
  },
  mounted: function () {
    this.draw()
  },
  components: {
    'key-value': KeyValue
  }
}
</script>

<style lang="less">
@import (reference) "~@oldShared/lasso/style/constants/colors";
  .donut-box {
    .donut-wrapper {
      position: relative;
      width: 135px;
      margin: 0 auto 25px auto;
      .donut-value {
        text-align: center;
        font-weight: 500;
        font-size: 22px;
        line-height: 22px;
        margin-top: -11px;
        position: absolute;
        top: 50%;
        left: 0;
        padding-left: 3px;
        width: 100%;
      }

      .donut-red { stroke: @red-primary; }
      .donut-yellow { stroke: #fcce0d; }
      .donut-green { stroke: #79ab00; }
      .donut-grey { stroke: #e5e5e5; }
    }
  }

  #app.xxs {
    .donut-box .donut-wrapper {
      width: 100px;
    }
  }
</style>
